import React from "react";

const PollLayout = ({ children }) => {
  return <>{children}</>;
};

export default PollLayout;
